/*
  This selector may be tweak in order to search the authorization
  within the user state.
 */
const getAuthorization = (state) => state.authorization;

export {
  getAuthorization
};
